export const truncateString = (str, maxLength) => {
  if (str.length > maxLength) {
    return `${str.slice(0, maxLength)}...`;
  }
  return str;
};
function checkWhitespaceBetweenCharacters(str) {
  const trimmedStr = str.trim();
  const characters = trimmedStr.split('');

  for (let i = 1; i < characters.length; i += 1) {
    if (characters[i] === ' ' && characters[i - 1] !== ' ') {
      return true;
    }
  }

  return false;
}
export const validateValueInputWord = (wordList, word) => {
  let empty = false;
  let duplicate = false;
  let invalid = false;
  let trim = false;
  const wordRegex = /^\s*[a-zA-Z0-9À-ỹ]+([&-][a-zA-Z0-9À-ỹ]+)*\.?\s*$/;

  const regex = new RegExp(wordRegex);
  if (
    !word.match(regex) ||
    word?.trim().length > 50 ||
    word?.trim().length < 2
  ) {
    invalid = true;
  }

  const isDuplicate = wordList.some(
    (item) => item.word.trim().toLowerCase() === word.trim().toLowerCase(),
  );
  if (!word) {
    empty = true;
  }
  if (isDuplicate) {
    duplicate = true;
  }

  if (checkWhitespaceBetweenCharacters(word)) {
    trim = true;
  }
  return [trim, empty, duplicate, invalid];
};

export const checkValidatePronunciation = (word, maxLength = 100) => {
  let invalid = false;
  let empty = false;
  let overMaxLength = false;
  const wordRegex = /^[a-zA-Z\u00C0-\u1EF9]+(?:[\s-]+[a-zA-Z\u00C0-\u1EF9]+)*$/;

  if (!word) {
    empty = true;
  }
  if (word?.trim()?.length > maxLength) {
    overMaxLength = true;
  }
  if (word && !wordRegex.test(word.trim())) {
    invalid = true;
  }

  return [invalid, empty, overMaxLength];
};
